<script>
export default {
  name: 'has-filters',
  computed: {
    currentVieName () {
      return this.$route.path.replace(/^a-z0-9\-\//gmi, '')
    }
  },
  data () {
    return {
      initialFilterValues: {}
    };
  },
  beforeMount () {
    this.initialFilterValues = JSON.parse(JSON.stringify(this.filters));
    this.loadFilters();
  },
  mounted () {
    this.$bus.$on('view-filters-save', this.saveFilters);
    this.$bus.$on('view-filters-reset', this.resetFilters);
  },
  methods: {
    loadFilters () {
      if (!localStorage.getItem('tw-pozyczki-crm-filters')) {
        this.resetFilters();
        return;
      }

      let filtersData = JSON.parse(localStorage.getItem('tw-pozyczki-crm-filters'));

      if (filtersData.view && filtersData.view === this.currentVieName) {
        this.filters = JSON.parse(JSON.stringify(filtersData.filters));

        if (this.filters.dateFrom) {
          this.dateRange.startDate = new Date(this.filters.dateFrom);
        }

        if (this.filters.dateTo) {
          this.dateRange.endDate = new Date(this.filters.dateTo);
        }
      } else {
        this.resetFilters();
      }
    },
    saveFilters () {
      let filtersData = {
        view: this.currentVieName,
        filters: this.filters
      };
      filtersData = JSON.stringify(filtersData);
      localStorage.setItem('tw-pozyczki-crm-filters', filtersData);
    },
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(this.initialFilterValues));
      this.saveFilters();
    }
  },
  beforeDestroy () {
    this.$bus.$off('view-filters-save', this.saveFilters);
    this.$bus.$off('view-filters-reset', this.saveFilters);
  }
}
</script>
